import validate from "/home/runner/work/diegomarmol.com/diegomarmol.com/node_modules/nuxt/dist/pages/runtime/validate.js";
import scroll_45position_45global from "/home/runner/work/diegomarmol.com/diegomarmol.com/src/middleware/scroll-position.global.ts";
import manifest_45route_45rule from "/home/runner/work/diegomarmol.com/diegomarmol.com/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  scroll_45position_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}